<template>
  <div
    class="form-group"
    :class="{
      'form-group--error' : errors.has(name),
      'form-group--required': isRequired
    }">
    <label
      :for="name"
      class="label">{{ label }}</label>
    <div class="input-file">
      <input
        :id="'file-attachments-' + _uid"
        v-validate="getRules"
        class="u-hidden"
        :name="name"
        :data-vv-as="label"
        accept="application/pdf"
        type="file"
        @change="attachFile">
      <input
        :placeholder="attachment.name ? attachment.name : 'No file chosen'"
        type="text"
        class="input u-border-radius-left"
        name="file_resume_name"
        readonly>
      <button
        class="button u-border-radius-right"
        @click.prevent="toggleClick">
        Browse
      </button>
    </div>
    <span
      v-if="errors.has(name) && showError"
      class="help-text help-text--error">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
import FormUtilities from './FormUtilities'

export default {
  mixins: [FormUtilities],
  data: () => ({
    attachment: {
      name: null
    }
  }),
  methods: {
    toggleClick () {
      document.getElementById(`file-attachments-${this._uid}`).click()
    },
    attachFile (e) {
      const file = e.target.files[0]

      this.attachment.name = file.name

      this.$emit('input', file)
    }
  }
}
</script>
